import { render, staticRenderFns } from "./Rich.vue?vue&type=template&id=0e3e38ff&scoped=true"
import script from "./Rich.vue?vue&type=script&lang=js"
export * from "./Rich.vue?vue&type=script&lang=js"
import style0 from "./Rich.vue?vue&type=style&index=0&id=0e3e38ff&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3e38ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e3e38ff')) {
      api.createRecord('0e3e38ff', component.options)
    } else {
      api.reload('0e3e38ff', component.options)
    }
    module.hot.accept("./Rich.vue?vue&type=template&id=0e3e38ff&scoped=true", function () {
      api.rerender('0e3e38ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinSetting/components/Rich.vue"
export default component.exports